<template>
  <div class="select-field s-text-left" :class="{ [fieldClassname]: fieldClassname, disabled: disabled}">
    <span>
      <s-label :label="label" class="s-font-medium" />
      <span v-if="showMandatory" class="s-text-danger-600">*</span>
    </span>

    <s-select
      autofocus
      :searchable="searchable"
      :clearable="clearable"
      :options="options"
      :disabled="disabled"
      @update="onUpdate"
      :value="value"
      :class="'c-flex-grow-1 ' + selectClassname"
    />

    <c-inline-error
      v-if="Boolean(error)"
      :message="error"
    />
    <slot name="hint"></slot>
    <div class="hint s-mt-1" v-if="!Boolean(error) && hint !== null">
      {{ hint }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectField",
  props: {
    label: {
      type: [String, Function],
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    onUpdate: {
      type: Function,
      required: true,
    },
    disabled: Boolean,
    clearable: Boolean,
    searchable: Boolean,
    selectClassname: {
      type: String,
      required: true,
    },
    fieldClassname: {
      type: String,
      required: false,
      default: "",
    },
    error: {
      type: String,
      required: false,
      default: undefined,
    },
    showMandatory: {
      type: Boolean,
      required: false,
      default: false,
    },
    hint: {
      type: [String, Function],
      required: false,
      default: undefined,
    },
  },
}
</script>

<style lang="scss">
.select-field {
  width: inherit;

  &.disabled {
    & .hint {
      opacity: 60%;
    }

    & .c-select > * {
      opacity: 60%;
    }
  }

  & .c-select {
    margin-bottom: 8px;
  }

  & .hint {
    font-size: 12px;
  }
}
</style>
